<template>
  <el-card>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }">Panel</el-breadcrumb-item>
      <el-breadcrumb-item>Página Home</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <div class="loading" v-loading="true" v-if="fecthItems.length === 0"></div>
    <template v-else>
      <app-modal-draggable
        v-if="modalDraggable"
        :content="tableQuery"
        :name="'title'"
        :table="'desktop'"
      ></app-modal-draggable>
      <app-table-paginate
        :routeEdit="routeEdit"
        :tableQuery="fecthItems"
        :tableColumns="tableColumns"
        :preview="preview"
        :limit="limit"
        :draggable="true"
        :search="true"
      ></app-table-paginate>
      <br />
      <el-button type="primary" size="medium" @click="nuevoRegistro()">
        Nuevo
        <i class="el-icon-circle-plus-outline el-icon-right"></i>
      </el-button>
    </template>
  </el-card>
</template>

<script>
import ApiService from "@/common/api.service";
import { INTRANET_URL } from "@/common/config";
import { mapGetters } from "vuex";
import { FECTH_TIPO_TEMPLATE_DESKTOP } from "@/store/actions.type";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import Draggable from "@/components/Dashboard/Modals/draggable";

export default {
  name: "List",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-modal-draggable": Draggable
  },
  async created() {
    this.preview = INTRANET_URL + "/modulo/";
    this.routeEdit = "/dashboard/" + this.$route.params.db + "/home-page/edit/";
    await this.getTemplates();
    this.$root.$on("delete", id => {
      this.eliminarRegistro(id);
    });
    this.$root.$on("draggable", e => this.showDraggable());
    this.$root.$on("closeModal", () => this.closeModal());
  },
  async beforeMount() {
    setTimeout(() => {
      if (typeof this.userAccessPlugins !== "undefined") {
        this.userAccessPlugins.filter(a => {
          if (a.name === "Notificaciones") this.access = a.value;
        });
      }
      this.init();
    }, 1000);
  },
   beforeDestroy() {
    this.$root.$off("delete", id => {
      this.eliminarRegistro(id);
    });
    this.$root.$off("draggable", e => this.showDraggable());
    this.$root.$off("closeModal", () => this.closeModal());
  },
  data() {
    return {
      tableColumns: [
        {
          prop: "icon",
          label: "Icono"
        },
        {
          prop: "title",
          label: "Título"
        },
        {
          prop: "template_id",
          label: "Plantilla"
        },
        {
          prop: "order_row",
          label: "Orden"
        },
        {
          prop: "auth",
          label: "Permisos"
        }
      ],
      tableQuery: {},
      searchQuery: "",
      routeEdit: null,
      deleterow: false,
      preview: null,
      templates: false,
      modalDraggable: false,
      limit: 10,
      access: []
    };
  },
  watch: {
    $route(to) {
      this.routeEdit =
        "/dashboard/" +
        this.$route.params.db +
        "/home-page/form/edit/" +
        this.$route.params.table +
        "/";
      this.init();
    }
  },
  methods: {
    async init() {
      await this.getPages();
    },
    nuevoRegistro() {
      this.$router.push(
        "/dashboard/" + this.$route.params.db + "/home-page/new"
      );
    },
    async getTemplates() {
      await this.$store
        .dispatch(FECTH_TIPO_TEMPLATE_DESKTOP)
        .then(response => (this.templates = response));
    },
    async getPages() {
      this.tableQuery = [];
      await ApiService.post("dashboard/table", {
        table: "desktop",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table")
      }).then(response => {
        if (response.data !== "Algo ha fallado") {
          ApiService.post("dashboard/table", {
            table: "desktop_auth",
            token: localStorage.getItem("token"),
            project_id: localStorage.getItem("table")
          }).then(r => {
            this.access = this.access.filter(function(item, pos, self) {
              return self.indexOf(item) == pos;
            });

            response.data.map(a => {
              this.access.map(p => {
                if (a.id == p) {
                  this.templates.map(e => {
                    if (a.template_id == e.id) {
                      a.template_id = e.template;
                    }
                  });
                  r.data.map(permisos => {
                    if (permisos.desktop == a.id) {
                      if (
                        permisos.areas ||
                        permisos.departments ||
                        permisos.categories
                      ) {
                        a.auth = true;
                      } else {
                        a.auth = false;
                      }
                    }
                  });
                  this.tableQuery.push(a);
                }
              });
            });
            this.tableQuery.sort(function(a, b) {
              return a.order_row - b.order_row;
            });
          });
        }
      });
    },
    async eliminarRegistro(id) {
      await ApiService.post("dashboard/delete", {
        table: "desktop",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: id
      }).then(response => {
        this.deleterow = response.data;

        if (this.deleterow == 1) {
          this.$message({
            type: "success",
            message: "Se ha eliminado correctamente"
          });
          this.getPages();
        } else {
          this.$message({
            type: "warning",
            message: this.deleterow
          });
        }
      });
    },
    showDraggable() {
      this.modalDraggable = true;
    },
    closeModal() {
      this.modalDraggable = false;
      this.init();
    }
  },
  computed: {
    fecthItems() {
      return this.tableQuery;
    },
    ...mapGetters(["userAccessPlugins"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/home/list.vue